import type { WebsiteHeaderPhotoSchema_VideoArch } from '@shared/types/WebsiteHeaderSettings.types';

export const VIDEO_ARCH_DEFAULT: WebsiteHeaderPhotoSchema_VideoArch = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoArch-v1_1_1.json',
  presentationLayout: 'videoArch',
  photos: [],
  video: undefined,
};
